import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserStateService } from '../user-state-service';

/**
 * Blocks routes that require write access to the account in the URL (:accountId param).
 * Read-only account members are redirected home; superadmins and write-capable members pass.
 *
 * Safe to check synchronously: UserStateService.initialize() populates accountMembers (which
 * hasWriteAccess reads) synchronously from the principal, before any of its async account/dataset
 * fetches — and initialize() is already called from AppComponent's constructor, ahead of routing.
 */
@Injectable({
    providedIn: 'root'
})
export class WriteAccessGuard implements CanActivate {
    constructor(
        private readonly userStateService: UserStateService,
        private readonly router: Router
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const accountId = Number(route.paramMap.get('accountId'));
        const allowed = this.userStateService.hasWriteAccess(accountId);

        if (!allowed) {
            this.router.navigate(['/']);
        }
        return allowed;
    }

}
